import { Route, Routes } from 'react-router-dom';

import EventDetails from './EventDetails';
import EventSignUp from './EventSignUp';

function EventModule() {
  return (
    <Routes>
      <Route path=":id" element={<EventDetails />} />
      <Route path=":id/sign-up" element={<EventSignUp />} />
    </Routes>
  );
}

export default EventModule;
